import script from "./UploadProgressBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadProgressBar.vue?vue&type=script&lang=ts&setup=true"

import "./UploadProgressBar.vue?vue&type=style&index=0&id=d4df8cbc&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4df8cbc"]])

export default __exports__